import { usePage } from "@inertiajs/vue3";

export function useHasSubscription() {
    const pageProps = usePage();

    //@ts-expect-error
    const subscribedValues = Object.values(pageProps.props.subscribed);

    const hasSubscription = subscribedValues.includes(true);

    return {
        hasSubscription,
    };
}
